import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function GoogleCallback() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    sessionStorage.removeItem("po_next");
    if (sp.get("error") || !sp.get("code")) {
      toast.error("Login com Google cancelado.");
      navigate("/entrar", { replace: true });
      return;
    }
    api
      .post("/auth/google/callback", { code: sp.get("code"), state: sp.get("state") })
      .then(({ data }) => {
        setUser(data);
        navigate(data.must_change_password ? "/trocar-senha" : data.next || "/perfil", { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        navigate("/entrar", { replace: true });
      });
  }, [sp, navigate, setUser]);

  return (
    <div className="flex flex-col items-center gap-4 py-24" data-testid="google-callback">
      <Loader2 className="h-10 w-10 animate-spin text-orange-500" />
      <p className="text-lg text-slate-700">Entrando com Google...</p>
    </div>
  );
}
